import { useState } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import clock from "../../clock.png"


function XDateFee(props)
{

    const [p_umowa_oplaty_id, setPUmowaOplatyId] = useState(props.p_umowa_oplaty_id)
    const [view,setView] = useState('link');
    const [row, setRow] = useState(null);

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            p_umowa_oplaty_id: p_umowa_oplaty_id
        };
       

        fetch( Config.url + '/rest_v1_kids,free_period', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setRow(res.result);                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const saveTab = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            p_umowa_oplaty_id: p_umowa_oplaty_id,
            data_od: row.data_od,
            data_do: row.data_do,
        };
       

        fetch( Config.url + '/rest_v1_kids,free_period_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        closeDialog(); 
                        if(props.onClose != undefined)   props.onClose();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  




    const goChange = () => {
        setView("dialog");
    }

    const closeDialog = () => {
        setView('link');
    }



    if(p_umowa_oplaty_id < 1)
        {
            return <div>
                 
            </div>
        }


    var dlg = null;

    if(view == 'dialog')
        {
            if(row == null) 
                {
                    getTab();
                    return <span></span>;
                }

            dlg = <div className="dlg_window dlg_type_y">
                    <div className="dlg_title">Okres obowiązywania stawki</div>            

                    <div className="dlg_msg">
                        
                        
                        <div>
                            Jeżeli chcesz, by stawka obowiązywała ciągle pozostał pole bez ustawionej daty. 
                        </div>

                            <div className="form_tab">                                

                                <div className="form_control">
                                    <div className="fieldName">Od dnia</div>
                                    <InputDate   userData={props.userData} value={row.data_od} err={errTab}  valChange={valChangeListener}  name="data_od" placeholder={"Od dnia: "} className=' w150 ' req='0' firstUp="1" />
                                </div>

                                <div className="form_control">
                                    <div className="fieldName">Do dnia</div>
                                    <InputDate   userData={props.userData} value={row.data_do} err={errTab}  valChange={valChangeListener}   name="data_do" placeholder={"Do dnia: "} className=' w150 ' req='0' firstUp="1" />
                                </div>

                            </div>


                    </div>

                    <div className="dlg_btn">
                          <div className="btn" atr-type="save" onClick={saveTab}>Zapisz</div>
                          &nbsp;&nbsp;
                          <div className="btn" atr-type="cancel" onClick={closeDialog}>Anuluj</div>
                    </div>
            </div>
        }


    return (
        <span >
             <span className="link_color" onClick={goChange} >    <img src={clock} className="img_clock" title="Zmień okres trwania stawki" /></span>
             {dlg}
        </span>
    )
}

export default XDateFee;